import script from "./OAtributosEsperados.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAtributosEsperados.vue?vue&type=script&lang=ts&setup=true"

import "./OAtributosEsperados.vue?vue&type=style&index=0&id=4b7e4d32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7e4d32"]])

export default __exports__